import { useNavigate } from "react-router-dom";

function FooterItem({ menu, subMenuList}) {
    const navigate = useNavigate();

    return (
        <div className="FooterItem">
            <div
                className="FooterItem-Menu"
                onClick={()=>navigate(menu.link)}
            >{menu.name}</div>
            {subMenuList.length>0 &&
                <div className="FooterItem-SubMenu">
                    {subMenuList.map(subMenu => (
                        <div
                            key={subMenu.name}
                            onClick={()=>navigate(subMenu.link)}
                        >{subMenu.name}</div>
                    ))}
                </div>
            }
        </div>
    );
}

export default FooterItem;